import React from 'react';
import { Col, Card, CardBody } from 'reactstrap';
import PropTypes from 'prop-types';
import { Skeleton } from '@mui/material';


/*=============================================
=            Card Toptals Conponent           =
=============================================*/
function CardTotals(props) {
  return (
    <Col xl={props.xl} md={props.md} sm={props.sm} data-testid={props['data-testid'] || 'cardstotal'}>
      <div style={{ borderRadius: '1.5rem' }} className={`${props.colorClass} card flex-row align-items-center align-items-stretch bg-maritimo`}>
        {props.loading ?
          <Skeleton height={80} width="30%" />
          :
          <div className={props.propertiesIcon}>
            {props.image}
          </div>
        }
        {props.loading ?
          <Skeleton height={80} width="70%" className="margin_left" /> :
          <div className={props.propertiesTitle}>
            <div className="mini-card-subtítulo">{props.title}</div>
            <div className="mini-card-number">{props.total}</div>
          </div>
        }
      </div>
    </Col>
  );
}

CardTotals.defaultProps = {
  xl: 3,
  md: 6,
  sm: 12,
};

CardTotals.propTypes = {
  xl: PropTypes.number,
  md: PropTypes.number,
  sm: PropTypes.number,
  propertiesIcon: PropTypes.string,
  image: PropTypes.element,
  propertiesTitle: PropTypes.string,
  total: PropTypes.number,
  title: PropTypes.string,
};

export default CardTotals;
